/**
 * Έλεγχοι τηλεφώνου για Ελλάδα και Κύπρο.
 *
 * Ελλάδα: κινητό 10 ψηφία 69XXXXXXXX, σταθερό 10 ψηφία 2…/8….
 * Κύπρος: κινητό 8 ψηφία που ξεκινούν από 9 (π.χ. 99123456), με ή χωρίς
 *         διεθνές πρόθεμα 357 (+357 99123456), σταθερό 8 ψηφία από 2.
 */

/** Κρατά μόνο ψηφία (αφαιρεί +, κενά, παύλες) και κόβει στα 12. */
export function normalizePhoneDigits(value: string): string {
  return (value ?? "").replace(/\D/g, "").slice(0, 12);
}

/** Αφαιρεί το πρόθεμα χώρας 30 (Ελλάδα) ή 357 (Κύπρος), αν υπάρχει. */
function stripCountryPrefix(digits: string): string {
  if (digits.startsWith("357") && digits.length > 8) return digits.slice(3);
  if (digits.startsWith("30") && digits.length > 10) return digits.slice(2);
  return digits;
}

/** Ελληνικό κινητό: 69XXXXXXXX. */
export function isGreekMobile(value: string): boolean {
  return /^69\d{8}$/.test(stripCountryPrefix(normalizePhoneDigits(value)));
}

/** Κυπριακό κινητό: 8 ψηφία που ξεκινούν από 9. */
export function isCyprusMobile(value: string): boolean {
  return /^9\d{7}$/.test(stripCountryPrefix(normalizePhoneDigits(value)));
}

/** Κινητό Ελλάδας ή Κύπρου. */
export function isMobilePhone(value: string): boolean {
  return isGreekMobile(value) || isCyprusMobile(value);
}

/** Σταθερό/υπηρεσίας: Ελλάδα 2…/8… (10 ψηφία) ή Κύπρος 2… (8 ψηφία). */
export function isLandlinePhone(value: string): boolean {
  const d = stripCountryPrefix(normalizePhoneDigits(value));
  return /^[28]\d{9}$/.test(d) || /^2\d{7}$/.test(d);
}

/** Έγκυρο τηλέφωνο επικοινωνίας (κινητό ή σταθερό, Ελλάδα ή Κύπρος). */
export function isValidContactPhone(value: string): boolean {
  return isMobilePhone(value) || isLandlinePhone(value);
}

export const PHONE_HELP_TEXT =
  "Κινητό Ελλάδας (69XXXXXXXX), σταθερό Ελλάδας (2…/8…) ή κυπριακό (9XXXXXXX / 2XXXXXXX).";

export const MOBILE_HELP_TEXT =
  "Κινητό Ελλάδας 69XXXXXXXX ή Κύπρου 9XXXXXXX (με ή χωρίς +357).";
